import React, {useState, useEffect} from "react";
import { Navigate } from "react-router-dom";
import { getReproductions } from "../../../api/reproductionApi";
import CroissanceWheel from "./adminCroissanceWheel";
import { changeReproductionStatus } from "../../../api/reproductionApi";

export const AdminCroissance = () => {
  const [reproductions, setReproductions] = useState([]);

  useEffect(() => {
    loadReproductions();
  }, []);

  const loadReproductions = () => {
    getReproductions().then(data => setReproductions(data));
  };

  const handleStatusChange = async (id, newStatus) => {
  try {
    await changeReproductionStatus(id, newStatus);

    const fresh = await getReproductions();
    setReproductions(fresh);

  } catch (err) {
    console.error("Status change failed:", err);
    throw err;
  }
};

  return (
    <div>
      <CroissanceWheel reproductions={reproductions} onStatusChange={handleStatusChange} />
    </div>
  );
};